import moment from "moment";
import Calendar from "react-calendar";
import { ReactComponent as CircleArrow } from "../../assets/icons/circle_arrow.svg";
import { useContext } from "react";
import { LocaleContext } from "../../AppProvider";

export const CheckOutCalendar = ({
  setDate,
  setMonth,
  date,
  disabledDateObj,
  isLoading,
  disabledCalendar
}: {
  setDate: (date: Date) => void;
  setMonth: (date: Date) => void;
  date: Date | undefined;
  disabledDateObj?: Partial<{
    month: number;
    data: string[];
  }>;
  isLoading: boolean;
  disabledCalendar: boolean;
}) => {
  const { t } = useContext(LocaleContext);

  return (
    <div
      className={`calendar_content ${
        disabledCalendar ? `calendar_disabled` : ``
      }`}
      style={{ position: "relative" }}
    >
      <Calendar
        onClickDay={setDate}
        onActiveStartDateChange={(changeInfo) => {
          const month = changeInfo.activeStartDate;

          setMonth(month);
        }}
        minDetail="year"
        minDate={new Date()}
        value={date}
        tileDisabled={({ activeStartDate, date, view }) => {
          if (disabledCalendar) {
            return true;
          }
          if (view === "month") {
            if (
              moment(date).format("MM") !== moment(activeStartDate).format("MM")
            ) {
              return true;
            } else if (
              !disabledDateObj ||
              disabledDateObj.month !== date.getMonth() ||
              isLoading
            ) {
              return true;
            } else {
              return (
                (disabledDateObj.data || []).indexOf(
                  moment(date).format("DD")
                ) >= 0
              );
            }
          } else {
            return false;
          }
        }}
        nextLabel={
          <div className="calendar_arrow_holder right">
            <CircleArrow className="img_div_contain" />
          </div>
        }
        prevLabel={
          <div className="calendar_arrow_holder left">
            <CircleArrow className="img_div_contain" />
          </div>
        }
        tileClassName={"calendar_tile_custom_name"}
        next2Label={null}
        prev2Label={null}
      />
      <div className="center calendar_loading">
        {/* {isLoading && !disabledCalendar ? t("Loading...") : ""} */}
        {isLoading && t("Loading...") ? t("Loading...") : ""}
      </div>
    </div>
  );
};

export default CheckOutCalendar;
